/*
 * @LastEditors: Please set LastEditors
 * @Date: 2022-08-24 10:14:30
 * @LastEditTime: 2023-03-31 21:46:25
 * @Descripttion:
 */
import { btnGrayNormalHandle, TGDialogS ,teamInfo,pageDataChange,initShareFunc,bindShare,copyText,getCFArea,getchannelCode,nomsg,closeDialog,realGoodGift,compare,weekPop} from '../utils'
import { amsBtn } from '../AmsAndMilo/amsBtnTypeLimit'
import { teamParams } from '../AmsAndMilo/teamComm'
import { iActivityId, initFlow, wxBindPopId, preRolePopId, plat,isPage,backUrl } from './config'
import LoginService from '../AmsAndMilo/loginService'
import * as milo from '@tencent/milo-web'
import { AmsService } from '../AmsAndMilo/amsSubmit'
declare function need(path: string | Array<string>, cb: Function): any
declare function amsSubmit(actid: number, flowid: number): any
declare const LivelinkManager
declare const CFbind

if(isPage=='H5'){
  milo.cookie.set("backUrl",backUrl,7200,"qq.com","/"); 
}
 
if(isPage!='nq'){
if((window as any).parent.location.href.match(/https\:\/\/cfhd.cf.qq.com/)&&(window as any).parent != (window as any)) {
  milo.miloAlert = (window as any).parent.milo.miloAlert
}
}
export function initPage(needSubmit: boolean = true, popMask: boolean = false) {
  if (needSubmit) {
    milo.Lottery.init({
      plat: plat,
      iActivityId:iActivityId,
      iFlowId: initFlow,
      withAreaInfo: false,
      forbidLoading: popMask || true,
      // flowConfig: {
      //   sData: sData
      // },
      onSuccess: (callbackObj) => {
        initFunction(callbackObj)
      },
      onFail: (callbackObj) => {
        // 抽奖失败事件
        // if (callbackObj.iRet == '202') {
        //   TGDialogS(wxBindPopId)
        //   milo.miloAlert(callbackObj.sMsg)
        // } else if (callbackObj.sMsg === '抱歉，您还没有角色，无法参与~' || callbackObj.sMsg === '抱歉，您还未拥有角色，无法参与~') {
        //   // 拉起来预创角
        //   milo.miloAlert(callbackObj.sMsg)
        //   TGDialogS(preRolePopId)
        // } else {
        //   milo.miloAlert(callbackObj.sMsg)
        // }
        return
      },
    }).then(lottory => {
      lottory.getGift()
    })
  } else {
    initFunction((window as any).cfhdCallbackObj[iActivityId])
  }
}
 
if ((window as any).cfhdCallbackObj == undefined) {
  (window as any).cfhdCallbackObj = {}
}
// ;(window as any).cfhdCallbackObj[iActivityId] = { sOutValue1: '', sOutValue2: '', sOutValue3: '', sOutValue4: '', sOutValue5: '', sOutValue6: '', sOutValue7: '', sOutValue8: '' }
// 需要开发人员手工更改  NEED-TODO
var btnClassList1: Array<amsBtn> = [
{class:'.HOLD547461_0',flowId:940870,key:'sOutValue1',postion:'0',params:{dmid701:1},before:CFfunb},//tab7-双区游戏一局抽奖_dmid701
{class:'.HOLD547461_1',flowId:941174,key:'sOutValue1',postion:'1',params:{dmid1:1}},//tab8新玩家一键领取_dmid1
{class:'.HOLD547461_2',flowId:941177,key:'sOutValue1',postion:'2',params:{dmid2:1},needInitSubmit:true},//tab8新玩家登录2选1_dmid2
{class:'.HOLD547461_3',flowId:941177,key:'sOutValue1',postion:'3',params:{dmid2:2},needInitSubmit:true},//tab8新玩家登录2选1_dmid2
{class:'.HOLD547461_4',flowId:941178,key:'sOutValue1',postion:'4',params:{dmid3:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab8登录邮件同意授权_dmid3
{class:'.HOLD547461_5',flowId:941179,key:'sOutValue1',postion:'5',params:{dmid4:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab8登录邮件取消授权_dmid4
{class:'.HOLD547461_6',flowId:941180,key:'sOutValue1',postion:'6',params:{dmid5:1},needInitSubmit:true},//tab8新玩家游戏2选1_dmid5
{class:'.HOLD547461_7',flowId:941180,key:'sOutValue1',postion:'7',params:{dmid5:2},needInitSubmit:true},//tab8新玩家游戏2选1_dmid5
{class:'.HOLD547461_8',flowId:941181,key:'sOutValue1',postion:'8',params:{dmid6:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab8游戏邮件同意授权2_dmid6
{class:'.HOLD547461_9',flowId:941182,key:'sOutValue1',postion:'9',params:{dmid7:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab8游戏邮件取消授权_dmid7
{class:'.HOLD547461_10',flowId:941208,key:'sOutValue1',postion:'10',params:{dmid8:1}},//tab8新玩家跳页面即领_dmid8
{class:'.HOLD547461_11',flowId:941209,key:'sOutValue1',postion:'11',params:{dmid9:1}},//tab8新玩家点下载_dmid9
{class:'.HOLD547461_12',flowId:941210,key:'sOutValue1',postion:'12',params:{dmid10:1}},//tab8-累计登录领奖励_dmid10
{class:'.HOLD547461_13',flowId:941210,key:'sOutValue1',postion:'13',params:{dmid10:2}},//tab8-累计登录领奖励_dmid10
{class:'.HOLD547461_14',flowId:941210,key:'sOutValue1',postion:'14',params:{dmid10:3}},//tab8-累计登录领奖励_dmid10
{class:'.HOLD547461_15',flowId:941210,key:'sOutValue1',postion:'15',params:{dmid10:4}},//tab8-累计登录领奖励_dmid10
{class:'.HOLD547461_16',flowId:941210,key:'sOutValue1',postion:'16',params:{dmid10:5}},//tab8-累计登录领奖励_dmid10
{class:'.HOLD547461_17',flowId:941210,key:'sOutValue1',postion:'17',params:{dmid10:6}},//tab8-累计登录领奖励_dmid10
{class:'.HOLD547461_18',flowId:941211,key:'sOutValue1',postion:'18',params:{dmid11:1}},//tab8-每日任务领奖励_dmid11
{class:'.HOLD547461_19',flowId:941211,key:'sOutValue1',postion:'19',params:{dmid11:2}},//tab8-每日任务领奖励_dmid11
{class:'.HOLD547461_20',flowId:941211,key:'sOutValue1',postion:'20',params:{dmid11:3}},//tab8-每日任务领奖励_dmid11
{class:'.HOLD547461_21',flowId:941212,key:'sOutValue1',postion:'21',params:{dmid12:1}},//tab8-成功分享领_dmid12
{class:'.HOLD547461_22',flowId:941651,key:'sOutValue1',postion:'22',params:{dmid13:1}},//tab9回归玩家5选3_dmid13
{class:'.HOLD547461_23',flowId:941651,key:'sOutValue1',postion:'23',params:{dmid13:2}},//tab9回归玩家5选3_dmid13
{class:'.HOLD547461_24',flowId:941651,key:'sOutValue1',postion:'24',params:{dmid13:3}},//tab9回归玩家5选3_dmid13
{class:'.HOLD547461_25',flowId:941651,key:'sOutValue1',postion:'25',params:{dmid13:4}},//tab9回归玩家5选3_dmid13
{class:'.HOLD547461_26',flowId:941651,key:'sOutValue1',postion:'26',params:{dmid13:5}},//tab9回归玩家5选3_dmid13
{class:'.HOLD547461_27',flowId:941652,key:'sOutValue1',postion:'27',params:{dmid14:1},needInitSubmit:true},//tab9回玩家登录2选1_dmid14
{class:'.HOLD547461_28',flowId:941652,key:'sOutValue1',postion:'28',params:{dmid14:2},needInitSubmit:true},//tab9回玩家登录2选1_dmid14
{class:'.HOLD547461_29',flowId:941653,key:'sOutValue1',postion:'29',params:{dmid15:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab9邮件同意授权_dmid15
{class:'.HOLD547461_30',flowId:941654,key:'sOutValue1',postion:'30',params:{dmid16:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab9邮件取消授权_dmid16
{class:'.HOLD547461_31',flowId:941656,key:'sOutValue1',postion:'31',params:{dmid17:1}},//tab9老玩家进web云游戏_dmid17
{class:'.HOLD547461_32',flowId:941657,key:'sOutValue1',postion:'32',params:{dmid18:1}},//tab9老玩家点下载_dmid18
{class:'.HOLD547461_33',flowId:941658,key:'sOutValue1',postion:'33',params:{dmid19:1}},//tab9-累登领奖励_dmid19
{class:'.HOLD547461_34',flowId:941658,key:'sOutValue1',postion:'34',params:{dmid19:2}},//tab9-累登领奖励_dmid19
{class:'.HOLD547461_35',flowId:941658,key:'sOutValue1',postion:'35',params:{dmid19:3}},//tab9-累登领奖励_dmid19
{class:'.HOLD547461_36',flowId:941658,key:'sOutValue1',postion:'36',params:{dmid19:4}},//tab9-累登领奖励_dmid19
{class:'.HOLD547461_37',flowId:941658,key:'sOutValue1',postion:'37',params:{dmid19:5}},//tab9-累登领奖励_dmid19
{class:'.HOLD547461_38',flowId:941658,key:'sOutValue1',postion:'38',params:{dmid19:6}},//tab9-累登领奖励_dmid19
{class:'.HOLD547461_39',flowId:941659,key:'sOutValue1',postion:'39',params:{dmid20:1}},//tab9-每日签到领奖励_dmid20
{class:'.HOLD547461_40',flowId:941678,key:'sOutValue1',postion:'40',params:{dmid21:1}},//tab9-每日登录领奖励_dmid21
{class:'.HOLD547461_41',flowId:941680,key:'sOutValue1',postion:'41',params:{dmid22:1}},//tab9-成功分享领_dmid22
{class:'.HOLD547461_42',flowId:941684,key:'sOutValue1',postion:'42',params:{dmid23:1}},//tab1-当天登录4选2_dmid23
{class:'.HOLD547461_43',flowId:941684,key:'sOutValue1',postion:'43',params:{dmid23:2}},//tab1-当天登录4选2_dmid23
{class:'.HOLD547461_44',flowId:941684,key:'sOutValue1',postion:'44',params:{dmid23:3}},//tab1-当天登录4选2_dmid23
{class:'.HOLD547461_45',flowId:941684,key:'sOutValue1',postion:'45',params:{dmid23:4}},//tab1-当天登录4选2_dmid23
{class:'.HOLD547461_46',flowId:941731,key:'sOutValue1',postion:'46',params:{dmid25:1}},//tab2-连续登录领奖励_dmid25
{class:'.HOLD547461_47',flowId:941731,key:'sOutValue1',postion:'47',params:{dmid25:2}},//tab2-连续登录领奖励_dmid25
{class:'.HOLD547461_48',flowId:941731,key:'sOutValue1',postion:'48',params:{dmid25:3}},//tab2-连续登录领奖励_dmid25
{class:'.HOLD547461_49',flowId:941734,key:'sOutValue1',postion:'49',params:{dmid26:1}},//tab2-非排位领奖励_dmid26
{class:'.HOLD547461_50',flowId:941734,key:'sOutValue1',postion:'50',params:{dmid26:2}},//tab2-非排位领奖励_dmid26
{class:'.HOLD547461_51',flowId:941734,key:'sOutValue1',postion:'51',params:{dmid26:3}},//tab2-非排位领奖励_dmid26
{class:'.HOLD547461_52',flowId:941738,key:'sOutValue1',postion:'52',params:{dmid27:1}},//tab2-分享新回领奖励_dmid27
{class:'.HOLD547461_53',flowId:941738,key:'sOutValue1',postion:'53',params:{dmid27:2}},//tab2-分享新回领奖励_dmid27
{class:'.HOLD547461_54',flowId:941745,key:'sOutValue1',postion:'54',params:{dmid28:1},needInitSubmit:true},//tab3-游戏领月道具_dmid28
{class:'.HOLD547461_55',flowId:941745,key:'sOutValue1',postion:'55',params:{dmid28:2},needInitSubmit:true},//tab3-游戏领月道具_dmid28
{class:'.HOLD547461_56',flowId:941745,key:'sOutValue1',postion:'56',params:{dmid28:3},needInitSubmit:true},//tab3-游戏领月道具_dmid28
{class:'.HOLD547461_57',flowId:941745,key:'sOutValue1',postion:'57',params:{dmid28:4},needInitSubmit:true},//tab3-游戏领月道具_dmid28
{class:'.HOLD547461_58',flowId:941745,key:'sOutValue1',postion:'58',params:{dmid28:5},needInitSubmit:true},//tab3-游戏领月道具_dmid28
{class:'.HOLD547461_59',flowId:941746,key:'sOutValue1',postion:'59',params:{dmid29:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab3邮件同意授权_dmid29
{class:'.HOLD547461_60',flowId:941747,key:'sOutValue1',postion:'60',params:{dmid30:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab3邮件取消授权_dmid30
{class:'.HOLD547461_61',flowId:941784,key:'sOutValue1',postion:'61',params:{dmid31:1},needInitSubmit:true},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_62',flowId:941784,key:'sOutValue1',postion:'62',params:{dmid31:2},needInitSubmit:true},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_63',flowId:941784,key:'sOutValue1',postion:'63',params:{dmid31:3},needInitSubmit:true},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_64',flowId:941784,key:'sOutValue1',postion:'64',params:{dmid31:4},needInitSubmit:true},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_65',flowId:941784,key:'sOutValue1',postion:'65',params:{dmid31:5}},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_66',flowId:941784,key:'sOutValue1',postion:'66',params:{dmid31:6}},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_67',flowId:941784,key:'sOutValue1',postion:'67',params:{dmid31:7}},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_68',flowId:941784,key:'sOutValue1',postion:'68',params:{dmid31:8}},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_69',flowId:941784,key:'sOutValue1',postion:'69',params:{dmid31:9}},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_70',flowId:941784,key:'sOutValue1',postion:'70',params:{dmid31:10}},//tab3-当天登录10选2_dmid31
{class:'.HOLD547461_71',flowId:941788,key:'sOutValue1',postion:'71',params:{dmid32:1},resolve:tsmsg,needInitSubmit:true},//tab2-非排位领抽奖次数_dmid32
{class:'.HOLD547461_72',flowId:941800,key:'sOutValue1',postion:'72',params:{dmid33:1},resolve:tsmsg,needInitSubmit:true},//tab3-邀请好友领抽奖次数_dmid33
{class:'.HOLD547461_73',flowId:941800,key:'sOutValue1',postion:'73',params:{dmid33:2},resolve:tsmsg,needInitSubmit:true},//tab3-邀请好友领抽奖次数_dmid33
{class:'.HOLD547461_74',flowId:941800,key:'sOutValue1',postion:'74',params:{dmid33:3},resolve:tsmsg,needInitSubmit:true},//tab3-邀请好友领抽奖次数_dmid33
{class:'.HOLD547461_75',flowId:941801,key:'sOutValue1',postion:'75',params:{dmid34:1},resolve:tsmsg,needInitSubmit:true},//tab3-邀请好友领额外抽奖次数_dmid34
{class:'.HOLD547461_76',flowId:941801,key:'sOutValue1',postion:'76',params:{dmid34:2},resolve:tsmsg,needInitSubmit:true},//tab3-邀请好友领额外抽奖次数_dmid34
{class:'.HOLD547461_77',flowId:941812,key:'sOutValue1',postion:'77',params:{dmid35:1}},//tab3-分享成功领奖励_dmid35
{class:'.HOLD547461_78',flowId:942079,key:'sOutValue1',postion:'78',params:{dmid36:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab4聚宝盆每日游戏_dmid36
{class:'.HOLD547461_79',flowId:942080,key:'sOutValue1',postion:'79',params:{dmid37:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab4聚宝盆每日掌火_dmid37
{class:'.HOLD547461_80',flowId:942081,key:'sOutValue1',postion:'80',params:{dmid38:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab4斗鱼虎牙聚宝盆升级_dmid38
{class:'.HOLD547461_81',flowId:942081,key:'sOutValue1',postion:'81',params:{dmid38:2},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab4斗鱼虎牙聚宝盆升级_dmid38
{class:'.HOLD547461_82',flowId:942114,key:'sOutValue1',postion:'82',params:{dmid39:1}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_83',flowId:942114,key:'sOutValue1',postion:'83',params:{dmid39:2}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_84',flowId:942114,key:'sOutValue1',postion:'84',params:{dmid39:3}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_85',flowId:942114,key:'sOutValue1',postion:'85',params:{dmid39:4}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_86',flowId:942114,key:'sOutValue1',postion:'86',params:{dmid39:5}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_87',flowId:942114,key:'sOutValue1',postion:'87',params:{dmid39:6}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_88',flowId:942114,key:'sOutValue1',postion:'88',params:{dmid39:7}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_89',flowId:942114,key:'sOutValue1',postion:'89',params:{dmid39:8}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_90',flowId:942114,key:'sOutValue1',postion:'90',params:{dmid39:9}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_91',flowId:942114,key:'sOutValue1',postion:'91',params:{dmid39:10}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_92',flowId:942114,key:'sOutValue1',postion:'92',params:{dmid39:11}},//tab4聚宝盆等级奖励_dmid39
{class:'.HOLD547461_93',flowId:942120,key:'sOutValue1',postion:'93',params:{dmid40:1},needInitSubmit:true,customMsg:'恭喜您成功提升等级~',btnStr:'已升级'},//tab4-提升活跃等级_dmid40
{class:'.HOLD547461_94',flowId:942121,key:'sOutValue1',postion:'94',params:{dmid41:1}},//tab4-团队人数奖励_dmid41
{class:'.HOLD547461_95',flowId:942121,key:'sOutValue1',postion:'95',params:{dmid41:2}},//tab4-团队人数奖励_dmid41
{class:'.HOLD547461_96',flowId:942121,key:'sOutValue1',postion:'96',params:{dmid41:3}},//tab4-团队人数奖励_dmid41
{class:'.HOLD547461_97',flowId:942121,key:'sOutValue1',postion:'97',params:{dmid41:4}},//tab4-团队人数奖励_dmid41
{class:'.HOLD547461_98',flowId:942121,key:'sOutValue1',postion:'98',params:{dmid41:5}},//tab4-团队人数奖励_dmid41
{class:'.HOLD547461_99',flowId:942122,key:'sOutValue1',postion:'99',params:{dmid42:1}},//tab4-活跃等级奖励_dmid42
{class:'.HOLD547461_100',flowId:942122,key:'sOutValue1',postion:'100',params:{dmid42:2}},//tab4-活跃等级奖励_dmid42
{class:'.HOLD547461_101',flowId:942122,key:'sOutValue1',postion:'101',params:{dmid42:3}},//tab4-活跃等级奖励_dmid42
{class:'.HOLD547461_102',flowId:942122,key:'sOutValue1',postion:'102',params:{dmid42:4}},//tab4-活跃等级奖励_dmid42
{class:'.HOLD547461_103',flowId:942122,key:'sOutValue1',postion:'103',params:{dmid42:5}},//tab4-活跃等级奖励_dmid42
{class:'.HOLD547461_104',flowId:942126,key:'sOutValue1',postion:'104',params:{dmid43:1},before:CFfunb},//tab7-CF登录4选1_dmid43
{class:'.HOLD547461_105',flowId:942126,key:'sOutValue1',postion:'105',params:{dmid43:2},before:CFfunb},//tab7-CF登录4选1_dmid43
{class:'.HOLD547461_106',flowId:942126,key:'sOutValue1',postion:'106',params:{dmid43:3},before:CFfunb},//tab7-CF登录4选1_dmid43
{class:'.HOLD547461_107',flowId:942126,key:'sOutValue1',postion:'107',params:{dmid43:4},before:CFfunb},//tab7-CF登录4选1_dmid43
{class:'.HOLD547461_108',flowId:942216,key:'sOutValue1',postion:'108',params:{dmid44:1},before:CFfunb},//tab7-CF游戏2选1_dmid44
{class:'.HOLD547461_109',flowId:942216,key:'sOutValue1',postion:'109',params:{dmid44:2},before:CFfunb},//tab7-CF游戏2选1_dmid44
{class:'.HOLD547461_110',flowId:942218,key:'sOutValue1',postion:'110',params:{dmid45:1},before:CFfunb},//tab7-双端游戏一局抽奖_dmid45（备用）
{class:'.HOLD547461_111',flowId:942231,key:'sOutValue1',postion:'111',params:{dmid46:1}},//tab10-游戏领月道具_dmid46
{class:'.HOLD547461_112',flowId:942232,key:'sOutValue1',postion:'112',params:{dmid47:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab10邮件同意授权_dmid47
{class:'.HOLD547461_113',flowId:942233,key:'sOutValue1',postion:'113',params:{dmid48:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab10邮件取消授权_dmid48
{class:'.HOLD547461_114',flowId:942234,key:'sOutValue1',postion:'114',params:{dmid49:1}},//tab10-当天登录5选1_dmid49
{class:'.HOLD547461_115',flowId:942234,key:'sOutValue1',postion:'115',params:{dmid49:2}},//tab10-当天登录5选1_dmid49
{class:'.HOLD547461_116',flowId:942234,key:'sOutValue1',postion:'116',params:{dmid49:3}},//tab10-当天登录5选1_dmid49
{class:'.HOLD547461_117',flowId:942234,key:'sOutValue1',postion:'117',params:{dmid49:4}},//tab10-当天登录5选1_dmid49
{class:'.HOLD547461_118',flowId:942234,key:'sOutValue1',postion:'118',params:{dmid49:5}},//tab10-当天登录5选1_dmid49
{class:'.HOLD547461_119',flowId:942235,key:'sOutValue1',postion:'119',params:{dmid50:1}},//tab10-累计登录领奖励_dmid50
{class:'.HOLD547461_120',flowId:942235,key:'sOutValue1',postion:'120',params:{dmid50:2}},//tab10-累计登录领奖励_dmid50
{class:'.HOLD547461_121',flowId:942235,key:'sOutValue1',postion:'121',params:{dmid50:3}},//tab10-累计登录领奖励_dmid50
{class:'.HOLD547461_122',flowId:942235,key:'sOutValue1',postion:'122',params:{dmid50:4}},//tab10-累计登录领奖励_dmid50
{class:'.HOLD547461_123',flowId:942235,key:'sOutValue1',postion:'123',params:{dmid50:5}},//tab10-累计登录领奖励_dmid50
{class:'.HOLD547461_124',flowId:942239,key:'sOutValue1',postion:'124',params:{dmid51:1}},//tab10-分享新回领奖励_dmid51
{class:'.HOLD547461_125',flowId:942239,key:'sOutValue1',postion:'125',params:{dmid51:2}},//tab10-分享新回领奖励_dmid51
{class:'.HOLD547461_126',flowId:942239,key:'sOutValue1',postion:'126',params:{dmid51:3}},//tab10-分享新回领奖励_dmid51
{class:'.HOLD547461_127',flowId:942299,key:'sOutValue1',postion:'127',params:{dmid52:1},customMsg:'成功加入爆破派~',btnStr:'已加入'},//tab5-选择阵营_dmid52
{class:'.HOLD547461_128',flowId:942299,key:'sOutValue1',postion:'128',params:{dmid52:2},customMsg:'成功加入团竞派~',btnStr:'已加入'},//tab5-选择阵营_dmid52
{class:'.HOLD547461_129',flowId:942422,key:'sOutValue1',postion:'129',params:{dmid53:1}},//tab5-获胜阵营奖励领取_dmid53（5.21开启）
{class:'.HOLD547461_130',flowId:942422,key:'sOutValue1',postion:'130',params:{dmid53:2}},//tab5-获胜阵营奖励领取_dmid53（5.21开启）
{class:'.HOLD547461_131',flowId:942509,key:'sOutValue1',postion:'131',params:{dmid54:1},needInitSubmit:true,grayClass:'no',customMsg:'成功领取爆破派积分*1，爆破派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_132',flowId:942509,key:'sOutValue1',postion:'132',params:{dmid54:2},needInitSubmit:true,grayClass:'no',customMsg:'成功领取爆破派积分*1，爆破派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_133',flowId:942509,key:'sOutValue1',postion:'133',params:{dmid54:3},needInitSubmit:true,grayClass:'no',customMsg:'成功领取爆破派积分*1，爆破派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_134',flowId:942509,key:'sOutValue1',postion:'134',params:{dmid54:4},needInitSubmit:true,grayClass:'no',customMsg:'成功领取爆破派积分*1，爆破派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_135',flowId:942509,key:'sOutValue1',postion:'135',params:{dmid54:5},needInitSubmit:true,grayClass:'no',customMsg:'成功领取爆破派积分*1，爆破派宝箱抽奖机会*2~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_136',flowId:942509,key:'sOutValue1',postion:'136',params:{dmid54:6},needInitSubmit:true,grayClass:'no',customMsg:'成功领取团竞派积分*1，团竞派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_137',flowId:942509,key:'sOutValue1',postion:'137',params:{dmid54:7},needInitSubmit:true,grayClass:'no',customMsg:'成功领取团竞派积分*1，团竞派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_138',flowId:942509,key:'sOutValue1',postion:'138',params:{dmid54:8},needInitSubmit:true,grayClass:'no',customMsg:'成功领取团竞派积分*1，团竞派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_139',flowId:942509,key:'sOutValue1',postion:'139',params:{dmid54:9},needInitSubmit:true,grayClass:'no',customMsg:'成功领取团竞派积分*1，团竞派宝箱抽奖机会*1~'},//tab5-完成任务领抽奖机会_dmid54
{class:'.HOLD547461_140',flowId:942509,key:'sOutValue1',postion:'140',params:{dmid54:10},needInitSubmit:true,grayClass:'no',customMsg:'成功领取团竞派积分*1，团竞派宝箱抽奖机会*2~'},//tab5-完成任务领抽奖机会_dmid54

{class:'.NOHOLD547461_4',flowId:941213,params:{sEncrypt:milo.request('sEncrypt')}},//tab8接受邀请-登录条件放开
{class:'.NOHOLD547461_5',flowId:941681,params:{sEncrypt:milo.request('sEncrypt')}},//tab9接受邀请-登录条件放开
{class:'.NOHOLD547461_6',flowId:941701,needInitSubmit:true},//tab1聚宝盆每日游戏
{class:'.NOHOLD547461_7',flowId:941737,params:{sEncrypt:milo.request('sEncrypt')}},//tab2接受邀请-登录条件放开
{class:'.NOHOLD547461_8',flowId:941804,params:{sEncrypt:milo.request('sEncrypt')}},//tab3接受邀请-登录条件放开
{class:'.NOHOLD547461_9',flowId:941815,needInitSubmit:true},//tab3-宝箱抽奖
{class:'.NOHOLD547461_10',flowId:941820,needInitSubmit:true},//tab3-额外宝箱抽奖
{class:'.NOHOLD547461_11',flowId:942116,needInitSubmit:true},//tab4-创建队伍
{class:'.NOHOLD547461_12',flowId:942117,before:getTeamid,needInitSubmit:true},//tab4-加入队伍
{class:'.NOHOLD547461_13',flowId:942118,needInitSubmit:true,resolve:nomsg,reject:nomsg},//tab4-换一批
{class:'.NOHOLD547461_14',flowId:942119,needInitSubmit:true},//tab4-成为推荐
{class:'.NOHOLD547461_15',flowId:942236,resolve:nomsg,reject:nomsg},//tab10-点分享
{class:'.NOHOLD547461_16',flowId:942237,params:{sEncrypt:milo.request('sEncrypt')}},//tab10接受邀请-登录条件放开修改新回条件
{class:'.NOHOLD547461_17',flowId:942238},//tab10-成功分享抽奖
{class:'.NOHOLD547461_18',flowId:942510,needInitSubmit:true},//tab5-爆破宝箱抽奖
{class:'.NOHOLD547461_19',flowId:942513,needInitSubmit:true},//tab5-团竞宝箱抽奖

{class:'.NOHOLD547461_1',flowId:940785,before:getNameAndChannel,customMsg:'创建成功~'},//预创角
{class:'.yunGame',flowId:940790,params:{click:1},resolve:yunGamejump,reject:yunGamejump},//新、老玩家点下载和跳转
{class:'.downGame',flowId:940790,params:{click:2},before:gameDownBefore,resolve:gameDown,reject:gameDown},//新、老玩家点下载和跳转
{class:'.widget',flowId:940784,before:getChannelItem,needInitSubmit:false},//渠道礼包领取


//引用4月初主活动
  {class:'.HOLD541575_0',flowId:934808, config: { iActivityId: 541575,giftId: 539248 },params:{dmid1:1}},//tab1登录领木兰_dmid1
  {class:'.HOLD541575_1',flowId:934809, config: { iActivityId: 541575,giftId: 539248 },params:{dmid2:1},resolve:closeDialog,needInitSubmit:true,customMsg:'成功开启续约提醒~',btnStr:'已同意'},//tab1邮件同意授权_dmid2
  {class:'.HOLD541575_2',flowId:934810, config: { iActivityId: 541575,giftId: 539248 },params:{dmid3:1},resolve:closeDialog,needInitSubmit:true,customMsg:'取消成功~',btnStr:'已取消'},//tab1邮件取消授权_dmid3
  {class:'.HOLD541575_3',flowId:934823, config: { iActivityId: 541575,giftId: 539248 },params:{dmid4:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1聚宝盆每日游戏_dmid4
  {class:'.HOLD541575_4',flowId:934824, config: { iActivityId: 541575,giftId: 539248 },params:{dmid5:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1聚宝盆每日掌火_dmid5
  {class:'.HOLD541575_5',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:1}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_6',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:2}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_7',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:3}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_8',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:4}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_9',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:5}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_10',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:6}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_11',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:7}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_12',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:8}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_13',flowId:934825, config: { iActivityId: 541575,giftId: 539248 },params:{dmid6:9}},//tab1聚宝盆等级奖励_dmid6
  {class:'.HOLD541575_154',flowId:938081, config: { iActivityId: 541575,giftId: 539248 },params:{dmid55:1},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1-斗鱼积分升级_dmid55
  {class:'.HOLD541575_155',flowId:938081, config: { iActivityId: 541575,giftId: 539248 },params:{dmid55:2},needInitSubmit:true,customMsg:'恭喜您成功提升聚宝盆等级~',btnStr:'已升级'},//tab1-斗鱼积分升级_dmid55

//引用4月中主活动
{class:'.HOLD544318_89',flowId:939009, config: { iActivityId: 544318,giftId: 540960 },params:{dmid28:1}},//TAB7-游戏一局领_dmid28

{class:'.HOLD544318_50',flowId:937903, config: { iActivityId: 544318,giftId: 540960 },params:{dmid15:1}},//TAB5-新地图领_dmid15

{class:'.HOLD544318_51',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:1}},//TAB5-累计游戏天数_dmid16
{class:'.HOLD544318_52',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:2}},//TAB5-累计游戏天数_dmid16
{class:'.HOLD544318_53',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:3}},//TAB5-累计游戏天数_dmid16
{class:'.HOLD544318_54',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:4}},//TAB5-累计游戏天数_dmid16
{class:'.HOLD544318_55',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:5}},//TAB5-累计游戏天数_dmid16
{class:'.HOLD544318_56',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:6}},//TAB5-累计游戏天数_dmid16
{class:'.HOLD544318_57',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:7}},//TAB5-累计游戏天数_dmid16
{class:'.HOLD544318_58',flowId:937905, config: { iActivityId: 544318,giftId: 540960 },params:{dmid16:8}},//TAB5-累计游戏天数_dmid16

{class:'.HOLD544318_59',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:1}},//TAB5-累计游戏天数_dmid17
{class:'.HOLD544318_60',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:2}},//TAB5-累计游戏天数_dmid17
{class:'.HOLD544318_61',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:3}},//TAB5-累计游戏天数_dmid17
{class:'.HOLD544318_62',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:4}},//TAB5-累计游戏天数_dmid17

{class:'.HOLD544318_63',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:5}},//TAB5-累计游戏天数_dmid17
{class:'.HOLD544318_64',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:6}},//TAB5-累计游戏天数_dmid17
{class:'.HOLD544318_65',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:7}},//TAB5-累计游戏天数_dmid17
{class:'.HOLD544318_66',flowId:937916, config: { iActivityId: 544318,giftId: 540960 },params:{dmid17:8}},//TAB5-累计游戏天数_dmid17

{class:'.HOLD544318_19',flowId:937190, config: { iActivityId: 544318,giftId: 540960 },params:{dmid6:1}},//TAB4-无条件领生化套_dmid6
{class:'.HOLD544318_20',flowId:937202, config: { iActivityId: 544318,giftId: 540960 },params:{dmid7:1}},//TAB4-无条件领生化角色_dmid7
{class:'.HOLD544318_21',flowId:937207, config: { iActivityId: 544318,giftId: 540960 },params:{dmid8:1}},//TAB4-新模式领_dmid8

{class:'.HOLD544318_22',flowId:937219, config: { iActivityId: 544318,giftId: 540960 },params:{dmid9:1}},//TAB4-团队人数奖励_dmid9
{class:'.HOLD544318_23',flowId:937219, config: { iActivityId: 544318,giftId: 540960 },params:{dmid9:2}},//TAB4-团队人数奖励_dmid9
{class:'.HOLD544318_24',flowId:937219, config: { iActivityId: 544318,giftId: 540960 },params:{dmid9:3}},//TAB4-团队人数奖励_dmid9
{class:'.HOLD544318_25',flowId:937219, config: { iActivityId: 544318,giftId: 540960 },params:{dmid9:5}},//TAB4-团队人数奖励_dmid9

{class:'.HOLD544318_26',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:1}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_27',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:2}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_28',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:3}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_29',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:4}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_30',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:5}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_31',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:6}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_32',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:7}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_33',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:8}},//TAB4-活跃等级奖励_dmid10
{class:'.HOLD544318_34',flowId:937224, config: { iActivityId: 544318,giftId: 540960 },params:{dmid10:9}},//TAB4-活跃等级奖励_dmid10

{class:'.HOLD544318_35',flowId:937259, config: { iActivityId: 544318,giftId: 540960 },params:{dmid11:1},resolve:getShb,needInitSubmit:true},//TAB4-1局奖励_dmid11
{class:'.HOLD544318_36',flowId:937826, config: { iActivityId: 544318,giftId: 540960 },params:{dmid12:1},resolve:getShb,needInitSubmit:true},//TAB4-3局奖励_dmid12
{class:'.HOLD544318_37',flowId:937842, config: { iActivityId: 544318,giftId: 540960 },params:{dmid13:1},resolve:getShb,needInitSubmit:true},//TAB4-累计游戏天数_dmid13
{class:'.HOLD544318_38',flowId:937842, config: { iActivityId: 544318,giftId: 540960 },params:{dmid13:2},resolve:getShb,needInitSubmit:true},//TAB4-累计游戏天数_dmid13
{class:'.HOLD544318_39',flowId:937842, config: { iActivityId: 544318,giftId: 540960 },params:{dmid13:3},resolve:getShb,needInitSubmit:true},//TAB4-累计游戏天数_dmid13
{class:'.HOLD544318_40',flowId:937842, config: { iActivityId: 544318,giftId: 540960 },params:{dmid13:5},resolve:getShb,needInitSubmit:true},//TAB4-累计游戏天数_dmid13

{class:'.HOLD544318_41',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:1},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_42',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:2},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_43',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:3},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_44',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:4},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_45',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:5},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_46',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:6},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_47',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:7},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_48',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:8},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14
{class:'.HOLD544318_49',flowId:937900, config: { iActivityId: 544318,giftId: 540960 },params:{dmid14:9},needInitSubmit:true},//TAB4-个人生化币兑换_dmid14

{class:'.NOHOLD544318_4',flowId:937902, config: { iActivityId: 544318,giftId: 540960 },needInitSubmit:true},//TAB4-个人生化币抽奖
{class:'.createTeam1',flowId:936644,config: {iActivityId: 544086,giftId: 541294},params:{afterfix:544318},needInitSubmit:true},//tab2-创建队伍
{class:'.joinTeam1',flowId:936645,config: {iActivityId: 544086,giftId: 541294},needInitSubmit:true,before:getTeamid3},//tab2-加入队伍-修改新回判定条件
{class:'.changeView1',flowId:936646,config: {iActivityId: 544086,giftId: 541294},params:{afterfix:544318},needInitSubmit:true,resolve:nomsg},//tab2-换一批
{class:'.tjTeam1',flowId:936647,config: {iActivityId: 544086,giftId: 541294},params:{afterfix:544318},needInitSubmit:true},//tab2-成为推荐团

//4月人拉人引用 
{class:'.HOLD541321_0',flowId:934486,config: {iActivityId: 541321,giftId: 538599},params:{dmid1:1},before:kolcfhddh},//tab1-兑换礼_dmid1
//5月人拉人引用
{class:'.HOLD546112_0',flowId:939062,config: {iActivityId: 546112,giftId: 542137},params:{dmid1:1},before:kolcfhddh2},//tab1-兑换礼_dmid1
{class:'.HOLD546112_0_1',flowId:939062,config: {iActivityId: 546112,giftId: 542137},params:{dmid1:1},before:kolcfhddh3},//tab1-兑换礼_dmid1
{class:'.HOLD546112_1',flowId:939063,config: {iActivityId: 546112,giftId: 542137},params:{dmid2:1}},//tab1-登录礼_dmid2
{class:'.HOLD546112_26',flowId:939078,config: {iActivityId: 546112,giftId: 542137},params:{dmid19:1}},//tab3-大咖认证礼_dmid19
{class:'.NOHOLD546112_1',flowId:939066,config: {iActivityId: 546112,giftId: 542137},needInitSubmit:true,customMsg:'恭喜您成功生成KOL口令码~'},//tab1-生成大咖码
]

const tab8CF = [
  {class:'.tab8_cf_func_gift1',flowId:937590, config: { iActivityId: 540298,giftId: 537920 } ,params:{dmid12:1, area: 0 },before:CFfunb},//tab8CF礼包
  {class:'.tab8_cf_func_gift2',flowId:937591, config: { iActivityId: 540298,giftId: 539103 } ,params:{dmid12:1, area: 0 },before:CFfunb},//tab8CF礼包
]

export const allBtn = [...btnClassList1, ...tab8CF]
export const amsService = new AmsService(allBtn) // amsService.allBtnPromise.get(890999).then((res) => { res.getGift() })可以这样调用, 也可以在别的页面应用amsService去调动

const dataPosition= ['t1gameweeks','t1jbpdj','gameweeks','t3cjnums','t3cjnums2','jbpdj','t89loginnums','t8weekgames','bpcjnums','tjcjnums','tab6jfnumticket','tab6gamenums','tab6gamedays','tab6jfnumtotal']
let pcUrl = 'https://cfhd.cf.qq.com/cp/a20230429act/index.html'
let h5Url = 'https://cfhd.cf.qq.com/cp/a20230429act/m.html'
let pagtInitStatus = 0;
let tab1Share:any;
let tab2Share:any;
let tab3Share:any;
let tab4Share:any;
let tab6Share:any;
let tab7Share:any;
let tab8Share:any;
let tab2TeamId:string;
let tab6TeamId:string;
let tab8TeamId:string;
let myKOLcode:string;
let cardinfo = [];

let area = 0;


// 初始化成功回调

// 需要开发人员手工更改  NEED-TODO
export function initFunction(callbackObj) {
  ;(window as any).cfhdCallbackObj[iActivityId] = callbackObj
  // 按钮置灰
  btnGrayNormalHandle((window as any).cfhdCallbackObj[iActivityId], allBtn, 'gray disable')
  // 页面数据处理
  pageDataChange((window as any).cfhdCallbackObj[iActivityId].sOutValue3,dataPosition)
  const DataArr = callbackObj.sOutValue3.split(',')

  
  let shareArr = callbackObj.sOutValue2.split(',')   
  myKOLcode = shareArr[1]==0?'':shareArr[1];
  $(".MYKOLCODE").val(myKOLcode);
  if(shareArr[3]>0){
    let listarr = {1:'QBZ-192 梦龙',2:'AK-47 山海经-九尾狐',3:'GALIL 山海经',4:'M4A1 WeGame专属',5:'R5 RGP 炫黄蜂巢'};
    $(".t3djnm").text(listarr[shareArr[3]]);
    $(".HOLD547461_59_1").attr('href',"javascript:TGDialogS('tab3_pop1')");
   }
  
   if(shareArr[4]>0){
    let listarr = {1:'AK-103 吸血鬼 猎狐',2:'沙漠之鹰 龙腾',3:'M200 巾帼花木兰 ',4:'M14EBR 神罚天使'};
    $(".t89djnm").text(listarr[shareArr[4]]);
    if(shareArr[4]<3){
      $(".HOLD547461_8_1").attr('href',"javascript:TGDialogS('tab8_pop3')");
    }else{
      $(".HOLD547461_29_1").attr('href',"javascript:TGDialogS('tab9_pop1')");			
    }
   }
   if(shareArr[5]>0){
    let listarr2 = {1:'QBZ-191+QBZ-191  美猴王',2:'AK-47+AK-47 哪吒闹海'};
    $(".t8djnm1").text(listarr2[shareArr[5]]);
    $(".HOLD547461_4_1").attr('href',"javascript:TGDialogS('tab8_pop1')");
   }
   $(".bpbfb").text(shareArr[6]+'%');
   $(".tjbfb").text((100-shareArr[6])+'%');
   $(".bpbfbjdt").width(shareArr[6]+'%');
   
  const zgarr = callbackObj.sOutValue1.split(',')
  if(zgarr[59]>0){
    $(".HOLD547461_59_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD547461_59_1").addClass('gray');
    $(".HOLD547461_59_1").text('已开启');
  }
  if(zgarr[60]>0){
    $(".HOLD547461_60_1").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD547461_60_1").addClass('gray');
    $(".HOLD547461_60_1").text('已取消');
  } 


  if(zgarr[4]>0){
    $(".HOLD547461_4_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD547461_4_1").addClass('gray');
    $(".HOLD547461_4_1").text('已开启');
  }
  if(zgarr[5]>0){
    $(".HOLD547461_5_1").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD547461_5_1").addClass('gray');
    $(".HOLD547461_5_1").text('已取消');
  }

  if(zgarr[8]>0){
    $(".HOLD547461_8_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD547461_8_1").addClass('gray');
    $(".HOLD547461_8_1").text('已开启');
  }
  if(zgarr[9]>0){
    $(".HOLD547461_9_1").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD547461_9_1").addClass('gray');
    $(".HOLD547461_9_1").text('已取消');
  } 

  if(zgarr[29]>0){
    $(".HOLD547461_29_1").attr('href',"javascript:alert('您已经开启过了哦');");
    $(".HOLD547461_29_1").addClass('gray');
    $(".HOLD547461_29_1").text('已开启');
  }
  if(zgarr[30]>0){
    $(".HOLD547461_30_1").attr('href',"javascript:alert('您已经取消了哦');");
    $(".HOLD547461_30_1").addClass('gray');
    $(".HOLD547461_30_1").text('已取消');
  } 

  let res4 = callbackObj.sOutValue4.split(',');
  
  for (var i=0;i<8;i++ ){
    if(i<4){
      if(res4[i]>0){
       $(".issy_"+i).text('是否剩余:是');
      }else{
       $(".issy_"+i).html('是否剩余:否');			
      }
    }else{
      let j = i-4;
      if(res4[i]>0){
        $(".issy_"+j).text('当前是否剩余:是');
      }else{
        $(".issy_"+j).html('当前是否剩余:否');			
      }
    }
  }
  let res5 = callbackObj.sOutValue5.split(',');
  for (var i=0;i<9;i++ ){
    if(res5[i]<1){
      $(".isnull_"+i).addClass('gray');
    }
  }
  if(res5[10]>0){
    $(".issy_t6").text('是');
  }else{
    $(".issy_t6").text('否');
  }
  cardinfo = callbackObj.sOutValue5.split(',');
  for(var i=0;i<4;i++){
    $(".cardscode_"+i).val(cardinfo[i])
  }
  const tab2Team = {
    teamInfo:(window as any).cfhdCallbackObj[iActivityId].sOutValue7,
    joinClass:".tab4_team",
    notJoinClass:".dont_join_team",
    teamIdClass:".team_id",
    tjBtnClass:".tjTeam",
    teamCountClass:".team_count",
    teamLevelJfName:"teamjfNum",
    jbpTeamLevelJfName:"",
    peopleLevelJfName:"peopleLevel",
    jbpPeopleLevelJfName:"",
    tjTeamListClass:".tab4_team_list"
  }

  tab2TeamId = teamInfo(tab2Team,942117);

  const tab6Team = {
  teamInfo:(window as any).cfhdCallbackObj[iActivityId].sOutValue8,//AMS返回团信息
  joinClass:".tab6_team", //加入团后的团信息div的class
  notJoinClass:".tab6dont_join_team", //未加入团的div的class
  teamIdClass:".tab6team_id",//显示团ID的input的class
  tjBtnClass:".tab6tjTeam",//推荐团的按钮class
  teamCountClass:".tab6team_count",//团队人数
  teamLevelJfName:"tab6team_level",//团队等级
  jbpTeamLevelJfName:"tab6team_zllevel",//jbp团队等级
  peopleLevelJfName:"tab6peopleLevel",//个人等级
  jbpPeopleLevelJfName:"tab6jbppeoplelevel1",//jbp个人等级
  tjTeamListClass:".tab6_team_list"//推荐团列表
  }
  tab6TeamId = teamInfo(tab6Team,942117);

  if(pagtInitStatus==0){
    
    pcUrl += '?sEncrypt=' + shareArr[0]
    h5Url += '?sEncrypt=' + shareArr[0]

    ;(window as any).tab1Share=initShareFunc(pcUrl+'&ctypeId=1',h5Url+'&ctypeId=1','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230429act/share.jpg',{width:255,height:245,class:'#tab1-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=1',{pcBtnClass: '.fxhy1',h5BtnClass: '.fxh51',zoneBtnClass: '.fxqq1',copyBtnClass: '.fxcp1',inputValClass: '#t1copytext'},(window as any).tab1Share);

    ;(window as any).tab2Share=initShareFunc(pcUrl+'&ctypeId=2',h5Url+'&ctypeId=2','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230429act/share2.jpg',{width:255,height:255,class:'#tab2-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=2',{pcBtnClass: '.fxhy2',h5BtnClass: '.fxh52',zoneBtnClass: '.fxqq2',copyBtnClass: '.fxcp2',inputValClass: '#t2copytext'},(window as any).tab2Share);

    ;(window as any).tab3Share=initShareFunc(pcUrl+'&ctypeId=3',h5Url+'&ctypeId=3','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230429act/share3.jpg',{width:275,height:265,class:'#tab3-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=3',{pcBtnClass: '.fxhy3',h5BtnClass: '.fxh53',zoneBtnClass: '.fxqq3',copyBtnClass: '.fxcp3',inputValClass: '#t3copytext'},(window as any).tab3Share);

    ;(window as any).tab4Share=initShareFunc(pcUrl+'&ctypeId=4',h5Url+'&ctypeId=4','CFHD海量枪械，刺激枪战！','邀你来领海量礼包福利','邀你来领海量礼包福利','https://game.gtimg.cn/images/cfhd/cp/a20230429act/share4.jpg',{width:275,height:265,class:'#tab4-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=4',{pcBtnClass: '.fxhy4',h5BtnClass: '.fxh54',zoneBtnClass: '.fxqq4',copyBtnClass: '.fxcp4',inputValClass: '#t4copytext'},(window as any).tab4Share);

    ;(window as any).tab6Share=initShareFunc(pcUrl+'&ctypeId=5',h5Url+'&ctypeId=5','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230429act/share5.jpg',{width:232,height:234,class:'#tab6-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=5',{pcBtnClass: '.fxhy6',h5BtnClass: '.fxh56',zoneBtnClass: '.fxqq6',copyBtnClass: '.fxcp6',inputValClass: '#t6copytext'},(window as any).tab6Share);
    
    ;(window as any).tab7Share=initShareFunc(pcUrl+'&ctypeId=6',h5Url+'&ctypeId=6','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230429act/share6.jpg',{width:225,height:225,class:'#tab7-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=6',{pcBtnClass: '.fxhy7',h5BtnClass: '.fxh57',zoneBtnClass: '.fxqq7',copyBtnClass: '.fxcp7',inputValClass: '#t7copytext'},(window as any).tab7Share);
    ;(window as any).tab8Share=initShareFunc(pcUrl+'&ctypeId=6',h5Url+'&ctypeId=6','免费领取 稀有皮肤','来领海量礼包福利，我在CFHD等你！','来领海量礼包福利，我在CFHD等你！','https://game.gtimg.cn/images/cfhd/cp/a20230429act/share6.jpg',{width:225,height:225,class:'#tab8-ewm'},'share');
    bindShare(pcUrl+'&ctypeId=6',{pcBtnClass: '.fxhy8',h5BtnClass: '.fxh58',zoneBtnClass: '.fxqq8',copyBtnClass: '.fxcp8',inputValClass: '#t8copytext'},(window as any).tab8Share);

    if (milo.request('sEncrypt') && milo.request('sEncrypt') != shareArr[0]) {
      if(milo.request('ctypeId') == 1){
        TGDialogS('tab2_pop2');//TAB2-接受邀请 
      }else if(milo.request('ctypeId') == 2){
        TGDialogS('tab3_pop3');//TAB3-接受邀请
      }else if(milo.request('ctypeId') == 3){
        TGDialogS('tab8_pop5');//TAB8-接受邀请
      }else if(milo.request('ctypeId') == 4){
        TGDialogS('tab9_pop3');//TAB9-接受邀请
      }else if(milo.request('ctypeId') == 5){
        TGDialogS('tab9_pop1');//TAB10-接受邀请 
      }
    }else{ 
      if(shareArr[2] == 1){
        (window as any).jump(9,'.tab-ct9');
      }else if(shareArr[2] == 2 || shareArr[2] == 4){
        (window as any).jump(8,'.tab-ct8');
      }
    }
    if (!milo.request('sEncrypt')) {
      weekPop(1)
    }    
    pagtInitStatus = 1
  }
}

//成功提示 
function tsmsg(callbackObj,ele){
  if(compare ('2023-04-23')){
    if(ele.flowId=='941800' || ele.flowId=='941788'){
      milo.miloAlert("恭喜您成功领取稀有奖池抽奖机会x1");
    }else{
      milo.miloAlert("恭喜您成功领取额外奖池抽奖机会x1");
    }
  }else{
    if(ele.flowId=='941800' || ele.flowId=='941788'){
      milo.miloAlert("恭喜您成功领取稀有奖池抽奖机会x2");
    }else{
      milo.miloAlert("恭喜您成功领取额外奖池抽奖机会x2");
    }
  }
}
function getShb(callbackObj,ele){
  milo.miloAlert(callbackObj.sMsg+"*"+callbackObj.jExtend)
  //initPage();
}
//执行传CF大区的方法
function CFfunb(ele){
  if(area>0){
    ;(window as any)[`sData${ele.class}`].area = area
    return true;
  }else{
    CFbind.initbind('myarea','bindarea()')
    return false;
  }
}


//加入团队
function joinTeam(tid,fid){
  if(fid==922015){
    if(area==0){
      CFbind.initbind('myarea','bindarea()')
      return false;
    }
  }
  LoginService(isPage).checkAndLogin().then(() => {
    amsPromise.then((lottery) => {
      lottery.getGift()
    })
  })
  
  const amsPromise = milo.Lottery.init({
    plat: plat,
    iActivityId: iActivityId,
    iFlowId: fid,
    withAreaInfo: false,
    forbidLoading: false,
    flowConfig:{
      sData: {
        'team_id':tid,
        'area':area
      }
    },
    onSuccess: (res) => {
      console.log(res)
      milo.miloAlert("加团成功~")
      initPage()
    },
    onFail: (err) => {
      milo.miloAlert(err.sMsg)
    },
  })
}


//购买
function djcbuy() {
  LoginService(isPage)
  .checkAndLogin()
  .then((check) => {
    amsSubmit(546112,939064)
  }) 
  
}

;(window as any).amsCfg_939064 = {
  'iActivityId' : '546112',
  'iFlowId' : '939064',
  'sData'	: {'sArea':600},
  '_everyRead': true, //_everyRead参数用于控制缓存，设为true表示每次发请求都会读取amsCfg参数的值，建议加上
  'fFlowSubmitEnd': function(res) {
    need(["ams.daoju_buy_svr.daoju_buy_svr"], function(DaojuBuy) {
      var option = {
        //apptype:4	新版webpay，已默认
        onPaySuccess:function(){
          //$(".38buy").addClass('gray').text('已购买')
        },//支付成功后回调方法
        //onPayClose:function(){}//关闭支付页面回调方法
      };
      DaojuBuy.svrPay(res.jData,option);
    });
  }, 
  'fFlowSubmitFailed':function(res) {
    milo.miloAlert(res.sMsg);
  }
};


//kol奖励兑换
function kolcfhddh(ele) {
  let kolcode = $(".kol-input").val();
  if(kolcode==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode
  return true;
}

//kol奖励兑换
function kolcfhddh2(ele) {
  let kolcode2 = $(".kol-input2").val();
  if(kolcode2==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode2
  return true;
}
//kol奖励兑换
function kolcfhddh3(ele) {
  let kolcode3 = $(".kol-input3").val();
  if(kolcode3==''){
    milo.miloAlert("请先输入兑换码~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].kolcode = kolcode3
  return true;
}
//拉取好友列表
let fuin = "";
let ftype = "";
let fex1 = "";
let algo_type = "";

function qqlist(){

  LoginService(isPage).checkAndLogin().then(() => {
    amsPromise.then((lottery) => {
      lottery.getGift()
    })
  })
  
  const amsPromise = milo.Lottery.init({
      plat: 'pc',
      iActivityId: '541575',
      iFlowId: '934774',
      withAreaInfo: false,
      onSuccess: (res) => {
          var list = res.jData.recommendlist;
          //if(list.length>0){
         /**var list = [
            {
              "userid": "1844137343",
              "nickname": "好友3",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "3091215065",
              "nickname": "好友4",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "1409602525",
              "nickname": "好友5",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "1956406663",
              "nickname": "好友6",
              "friendtype": "2",
              "ext1": "2"
            },
            {
              "userid": "3120507715",
              "nickname": "好友7",
              "friendtype": "2",
              "ext1": "2"
            }
          ]**/
          if(list!=null){
            var qqlisthtml = '';
            var qqlisthtml5 = '';
            fuin = "";
            ftype = "";
            fex1 = "";
            algo_type = "";
            for (var i=0;i<list.length ;i++ ){
              qqlisthtml +=  '<tr>';
              qqlisthtml +=  		'<td>'+resetqq(list[i]['userid'])+' </td>';
              qqlisthtml +=  		'<td>'+list[i]['nickname']+'</td>';
              qqlisthtml +=  		'<td><div class="codec"><img src="http://q3.qlogo.cn/headimg_dl?bs=uin&dst_uin='+list[i]["userid"]+'&spec=100&url_enc=0&referer=bu_interface&term_type=PC" alt=""></div></td>';
              qqlisthtml +=  		'<td><a href="javascript:sendqq('+list[i]["userid"]+',1,0,'+list[i]["friendtype"]+','+list[i]["ext1"]+');" class="btn-zs1 sp2"  onclick="PTTSendClick(\'btn\',\'t2ct1-zs1\',\'赠送\');">赠送</a></td>';
              qqlisthtml +=  	'</tr>';  

              fuin=fuin+","+list[i]['userid'];
              ftype=ftype+","+list[i]['friendtype'];
              fex1=fex1+","+list[i]['ext1'];
              algo_type= res.jData.algo_type;
            }
            $(".hylist").html(qqlisthtml);
          }else{
            //$(".t2ct1-box").hide();
            //$(".btn-yjzs1").hide();
            //$(".btn-yjzs2").hide();
            //$(".t2ct1-box1").show();
          }
      },
      onFail: (err) => {
          milo.miloAlert(err.sMsg || err.msg)
      },
  })

}

//给好友发消息
function sendqq(fuinDmSet,num,isFive,stype,ext1){
  milo.Lottery.init({
    plat: 'pc',
    iActivityId: '541575',
    iFlowId: '934775',
    flowConfig: {
      sData: {
        "fuin": fuinDmSet,
        "stype": stype,
        "ext1": ext1,
        "algo_type": algo_type
      }
    },
    withAreaInfo: false,
    onSuccess: (res) => {
      var fuinDm = fuin.split(",");
			var ftypeDm = ftype.split(",");
			var fex1Dm = fex1.split(",");
			if((fuinDm.length)-1>num&&isFive==1){
				var j = num+1;
				sendqq(fuinDm[j],j,1,ftypeDm[j],fex1Dm[j]);
			}else{
				if(res.iRet==0){
					milo.miloAlert("恭喜您，分享成功~")
				}else{
					milo.miloAlert("抱歉，分享失败~")
				}
			}
    },
    onFail: (err) => {
        //milo.miloAlert(err.sMsg || err.msg)
        var fuinDm = fuin.split(",");
        var ftypeDm = ftype.split(",");
        var fex1Dm = fex1.split(",");
        if((fuinDm.length)-1>num&&isFive==1){
          var j = num+1;
          sendqq(fuinDm[j],j,1,ftypeDm[j],fex1Dm[j]);
        }else{
          milo.miloAlert("抱歉，分享失败~")
        }
    },
  }).then(lottery => {
      lottery.getGift()
  })
}

function sendQQall(isFive){
    if(fuin){
      var fuinDm = fuin.split(",");
		  var ftypeDm = ftype.split(",");
		  var fex1Dm = fex1.split(",");
      sendqq(fuinDm[1],1,isFive,ftypeDm[1],fex1Dm[1]);
    }else{
      milo.miloAlert('请选择好友~')
    }
}
function getTeamid(ele){
  let teamid = $(".team_id_copy").val();  
  if(teamid==''){
    milo.miloAlert("请填写要加入的团队ID~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].team_id = teamid
  return true;
}

function getTeamid2(ele){
  if(area>0){
    let team_id2 = $(".team_id_copy2").val();  
    if(team_id2==''){
      milo.miloAlert("请填写要加入的团队ID~")
      return false;
    }
    ;(window as any)[`sData${ele.class}`].area = area
    ;(window as any)[`sData${ele.class}`].team_id = team_id2
    return true;
  }else{
    CFbind.initbind('myarea','bindarea()')
    return false;
  }
}

function getTeamid3(ele){
  let teamid = $(".team_id_copy3").val();  
  if(teamid==''){
    milo.miloAlert("请填写要加入的团队ID~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].team_id = teamid
  ;(window as any)[`sData${ele.class}`].afterfix = 544318
  return true;
}

function getNameAndChannel(ele){
  let preNickName = $(".preNickName").val()
  if(preNickName==''){
    milo.miloAlert("请填写角色名称~")
    return false;
  }
  let urlInfo = window.location.href.split('/');
  if(urlInfo[5]=='qd'){ 
    var hkChannel = getchannelCode(6)
  }else{
    var hkChannel = getchannelCode(5)
  }
  
  if(hkChannel==undefined){
    milo.miloAlert("抱歉，不是允许的渠道~")
    return false;
  }
  ;(window as any)[`sData${ele.class}`].preNickName = preNickName
  ;(window as any)[`sData${ele.class}`].hkChannel = hkChannel
  return true;
}

var channelItemArr = {
  hy: 1,
  djc: 2,
  gj: 3,
  llq: 4,
  wegame: 5,
  wegames: 5,
  hyh5: 1,
  djch5: 2
}
/*$('.widget').click(function () {
  channelJob()
})*/
function getChannelItem(ele) {
  let urlInfo = window.location.href.split('/');
  var urlArr = urlInfo[6].split('.')
  var Channelid = channelItemArr[urlArr[0]]
  if (!Channelid) {
    milo.miloAlert('渠道错误~')
    return false;
  }
  ;(window as any)[`sData${ele.class}`].dmidqd = Channelid
  return true;

}


function copyTeamId(){
  if(tab2TeamId){
    copyText(tab2TeamId,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先加入团队再来复制哦~")
  }
}
function copyTeamId2(){
  if(tab6TeamId){
    copyText(tab6TeamId,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先加入团队再来复制哦~")
  }
}
function copyTeamId3(){
  if(tab8TeamId){
    copyText(tab8TeamId,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先加入团队再来复制哦~")
  }
}
function copyKOLId(){
  if(myKOLcode){
    copyText(myKOLcode,milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先生成大咖码再来复制哦~")
  }
}
function copycard(id){
  if(cardinfo[id]){
    copyText(cardinfo[id],milo.miloAlert("复制成功~"));
  }else{
    milo.miloAlert("抱歉请先登录页面再来复制哦~")
  }
}
//云游戏跳转
function yunGame() {
  if(isPage == 'index'){
    //window.location.href = 'https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD';
    open('https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD');
  }else{
    milo.miloAlert('请去PC活动页面参加')
  }
}
//云游戏跳转
function yunGamejump() {
  if(isPage == 'H5'){
    window.location.href = 'https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD#/';
  }else{
    window.open('https://start.qq.com/game/cfhd/?ADTAG=web-cf-zb-HD#/');
  }
}

function gameDown(){
  if(isPage == 'H5'){
    //window.location.href = 'https://cfhd.cf.qq.com/cp/a20210607download/';
  }else{
    window.open('https://cfhd.cf.qq.com/cp/a20210607download/');
  }
}

function gameDownBefore(){
  if(isPage == 'H5'){
    milo.miloAlert('请前往PC端下载')
    return false;
  }
  return true;
}


//绑定cf大区
function bindarea() {
  if (CFbind.CFareaid > 0) {
    area = CFbind.CFareaid    
    if (isPage == 'H5') {
      $('#myarea').text(CFbind.CFareaname)
    } else {
      $('#myarea').text(CFbind.CFareaname + ' ' + CFbind.CFername)
    }
    milo.miloAlert('绑定大区成功')
    closeDialog()
  } else {
    milo.miloAlert('在该服务器上未获取到角色信息！')
  }
}


//绑定平台
function binddypt(){
  if(isPage=='index'){
    var instance = new LivelinkManager();
    instance.init({
      actId: 3648, // 活动ID
      gameId: 'cfhd', // 游戏ID
      loginType: 'ptlogin', // 登录方式 
      closeAfterBind: true, // 绑定成功后是否关闭弹窗
      gameAuthScene: 'act_3836', // 授权场景值
      onBoundSuccess(data) { // 绑定账号成功的回调
      var dyid = data.platAccount.uid;
      var dynick = decodeURIComponent(data.platAccount.nickName);
      if(dyid){
        initPage();
      }
      //console.log('onBoundSuccess', data);
      },
      onBoundError(errData) { // 绑定账号失败的回调
      console.log('onBoundError', errData);
      },
      initialedEvent(data) { // 初始化成功的回调
      console.log('initialedEvent', data);
      },
    });
  }else{
    milo.miloAlert("请先去PC活动页绑定平台账号再来参与活动哦~")
  }
}

function bindhypt(){
  if(isPage=='index'){
    var instance = new LivelinkManager();
    instance.init({
      actId: 3647, // 活动ID
      gameId: 'cfhd', // 游戏ID
      loginType: 'ptlogin', // 登录方式 
      closeAfterBind: true, // 绑定成功后是否关闭弹窗
      gameAuthScene: 'act_3837', // 授权场景值
      onBoundSuccess(data) { // 绑定账号成功的回调
      let hyid = data.platAccount.uid;
      let hynick = decodeURIComponent(data.platAccount.nickName);
      if(hyid){
        initPage();
      }
      //console.log('onBoundSuccess', data);
      },
      onBoundError(errData) { // 绑定账号失败的回调
      console.log('onBoundError', errData);
      },
      initialedEvent(data) { // 初始化成功的回调
      console.log('initialedEvent', data);
      },
    });
  }else{
    milo.miloAlert("请先去PC活动页绑定平台账号再来参与活动哦~")
  }
}

function bindkspt(){
  if(isPage=='index'){
    var instance = new LivelinkManager();
    instance.init({
      actId: 4610, // 活动ID
      gameId: 'cfhd', // 游戏ID
      loginType: 'ptlogin', // 登录方式 
      closeAfterBind: true, // 绑定成功后是否关闭弹窗
      gameAuthScene: 'act_4610', // 授权场景值
      onBoundSuccess(data) { // 绑定账号成功的回调
      let ksid = data.platAccount.uid;
      let hynick = decodeURIComponent(data.platAccount.nickName);
      if(ksid){
        initPage();
      }
      //console.log('onBoundSuccess', data);
      },
      onBoundError(errData) { // 绑定账号失败的回调
      console.log('onBoundError', errData);
      },
      initialedEvent(data) { // 初始化成功的回调
      console.log('initialedEvent', data);
      },
    });
  }else{
    milo.miloAlert("请先去PC活动页绑定平台账号再来参与活动哦~")
  }
}

//屏蔽中间4位数字
function resetqq(qq) {
  var str = String(qq)
  var len = str.length;
  if (len >= 7) {
    var reg = str.slice(-7, -3)
    return str.replace(reg, "****")
  } else if (len < 7 && len >= 6) {
    //1234567
    var reg = str.slice(-4, -2)
    return str.replace(reg, "**")
  } else if (len < 6 && len >= 4) {
    //1234567
    var reg = str.slice(-2, -1)
    return str.replace(reg, "**")
  }else{
	return 	str;
  }
}

//跳转tab
function jumpttt(tabIndex, el) {
  $('.nav a').eq(tabIndex - 1).addClass('on').siblings().removeClass('on')
  var index=$('.nav a').eq(tabIndex - 1).attr("data-navbtn");
  (window as any).iTab(index);
  $(".tab-box>.tab-ct").each(function(){
      var ct=$(this).attr("data-ct");
          if(index==ct){
              $(this).show().siblings().hide();
          }
  })
  var timer = setTimeout(function () {
      if(el==".top"){
          $(window).scrollTop(0); 
      }else{
          var elSt = $(el).offset().top;
          $(window).scrollTop(elSt);
      }
  }, 100)
}


;(window as any).yunGamejump = yunGamejump  
;(window as any).copyTeamId = copyTeamId
;(window as any).copyTeamId2 = copyTeamId2
;(window as any).copyTeamId3 = copyTeamId3
;(window as any).copyKOLId = copyKOLId
;(window as any).yunGame = yunGame
;(window as any).binddypt = binddypt
;(window as any).bindkspt = bindkspt
;(window as any).bindarea = bindarea 
;(window as any).joinTeam = joinTeam
;(window as any).djcbuy = djcbuy
;(window as any).initPage = initPage
;(window as any).sendqq = sendqq
;(window as any).qqlist = qqlist
;(window as any).sendQQall = sendQQall
;(window as any).copycard = copycard
;(window as any).milo.miloAlert = milo.miloAlert
;(window as any).LoginService = LoginService



